export default (props, vars) =>
  `${props?.['thickness'] || '4px'} rgba(0, 0, 0, 0) solid`;
